import { get, post } from "../../utils/net";

import type {
  FacilityPreferences,
  FacilityServiceFieldSetting,
} from "../../models/facilitySettings";

const baseURL = process.env.REACT_APP_API_PATH;

const getFacilityFieldSettings = (
  facility: string,
  type: string,
  isInterfaceMode?: boolean,
): Promise<FacilityServiceFieldSetting[]> => {
  const url = `${baseURL}/api/fieldsettings/${facility}/${type}?interfaced=${isInterfaceMode ? "true" : "false"}`;

  const extraOptions = {
    useExactPath: true,
  };

  return get(url, extraOptions).then((result) => {
    const settings: FacilityServiceFieldSetting[] = result.body.map((setting) => ({
      ...setting,
    }));

    return settings;
  });
};

const getPracticeFieldSettings = (
  facility: string,
  isInterfaceMode?: boolean,
): Promise<FacilityServiceFieldSetting[]> => {
  const url = `${baseURL}/api/fieldsettings/${facility}?interfaced=${isInterfaceMode ? "true" : "false"}`;

  const extraOptions = {
    useExactPath: true,
  };

  return get(url, extraOptions).then((result) => {
    const settings: FacilityServiceFieldSetting[] = result.body.map((setting) => ({
      ...setting,
    }));

    return settings;
  });
};

const getFacilityFormPreferences = (
  facility: string,
  preferencesType: string,
): Promise<FacilityServiceFieldSetting[]> => {
  const url = `${baseURL}/api/facilities/${facility}/${preferencesType}`;
  const extraOptions = {
    useExactPath: true,
  };

  return get(url, extraOptions).then((result) => result.body);
};

const getAllFacilityFormPreferences = (facility: string): Promise<FacilityPreferences> => {
  const preferencesCalls: Promise<object>[] = [];

  preferencesCalls.push(
    getFacilityFormPreferences(facility, "GeneralPreferences").then((results) => ({
      name: "GeneralPreferences",
      values: results,
    })),
  );

  preferencesCalls.push(
    getFacilityFormPreferences(facility, "OutPatientPreferences").then((results) => ({
      name: "OutPatientPreferences",
      values: results,
    })),
  );

  preferencesCalls.push(
    getFacilityFormPreferences(facility, "InPatientPreferences").then((results) => ({
      name: "InPatientPreferences",
      values: results,
    })),
  );

  return Promise.all(preferencesCalls).then((results) => {
    const allPreferences: FacilityPreferences = {};

    results.forEach((prefs: { name: string; values: object }) => {
      if (prefs) {
        allPreferences[prefs.name] = prefs.values;
      }
    });

    return allPreferences;
  });
};

const updateFacilityFormPreferences = (
  facility: string,
  preferencesType: string,
  preferences,
): Promise<FacilityServiceFieldSetting[]> => {
  const url = `${baseURL}/api/facilities/${facility}/${preferencesType}`;
  const extraOptions = {
    useExactPath: true,
  };

  return post(url, preferences, extraOptions).then((result) => result.body);
};

const getFacilityPreferences = (facility: string): Promise<FacilityPreferences> => {
  const url = `${baseURL}/api/ChoiceLists/facility/${facility}`;

  const extraOptions = {
    useExactPath: true,
  };

  return get(url, extraOptions).then((result: { body: FacilityPreferences }) => result.body);
};

export const facilitySettingsAPI = {
  getFacilityFieldSettings,
  getPracticeFieldSettings,
  getFacilityPreferences,
  getAllFacilityFormPreferences,
  updateFacilityFormPreferences,
};
